import $ from 'jquery';

const splitSection = function splitSection() {
  const $splitSectionItem = $('.split-section__item');
  if ($splitSectionItem && $splitSectionItem.length) {
    $splitSectionItem.each((ev, item) => {
      const $item = $(item);
      const $title = $item.find('.split-section__title');
      const $link = $item.find('.split-section__link');
      const $content = $item.find('.split-section__content');
      const $contentHeight = $content.outerHeight();
      $title.css('transform', `translateY(${$contentHeight / 2}px)`);
      $link.css('transform', `translateY(${$contentHeight / -2}px)`);
    });

    $splitSectionItem.hover(ev => {
      let $self = $(ev.target);
      if (!$self.hasClass('split-section__item')) {
        $self = $self.closest('.split-section__item');
      }
    });
  }
};
export default splitSection;



// WEBPACK FOOTER //
// ./src/scripts/modules/split-section.js